import classNames from "classnames";
import React from "react";
import { withRouter } from "react-router-dom";
import mainCss from "../style.scss";
import css from "./style.scss";
import CreateTeamProfile from "./createTeamProfile";
import ReviewTeam from "./reviewTeam";
import SuccessTeamProfile from "./successTeamProfile";
import MultiStepForm from "components/MultiStepForm";
import FormStep from "components/MultiStepForm/FormStep";
import { FormProvider } from "../../../context/FormContext";
import {profileValidationSchema, reviewTeamValidationSchema } from "./validationSchemas";
import { connect, useDispatch, useSelector } from "react-redux";
import LeaveMessagePopup from "../modals/LeaveMessage";
import { selectSelectedTeamMember, selectTeamMembers, selectUserId, selectIsPaidUser, selectPlanTypesByUserType } from "data/user/selectors";
import { upgradeFullAccessTeamMemberAPI } from "../../../data/user";
import { useEffect } from "react";
import { selectedTeamMember, getPlansTypeAPI } from "data/user/actions";
import { useState } from "react";

const ReviewTeamMemberProfile = ({history,leaveMessagePopup}) => {

  const dispatch = useDispatch();
  const userID = useSelector(selectUserId);
  const isPaidUser = useSelector(selectIsPaidUser);
  const planMrc = useSelector(selectPlanTypesByUserType('TEAM_FULL', isPaidUser));
const selectedMember = useSelector(selectSelectedTeamMember)?.toJS();
const allTeamMembers = useSelector(selectTeamMembers);
const pathParts = history?.location?.pathname?.split('/');
const memberId = pathParts?.[pathParts.length - 1];
const fallbackMember = allTeamMembers?.find(
  m => m?.userId?.toString() === memberId?.toString()
);

useEffect(() => {
  dispatch(getPlansTypeAPI(userID));
}, [userID]);

useEffect(() => {
  if (!selectedMember?.userId && fallbackMember?.userId) {
    dispatch(selectedTeamMember(fallbackMember));
  }
}, [selectedMember, fallbackMember, dispatch]);

const teamMemberDetails = selectedMember?.userId ? selectedMember : fallbackMember;
// Setting the team member's confirm email to the email
if (teamMemberDetails && teamMemberDetails.username) {
  teamMemberDetails.confirmEmail = teamMemberDetails.username;
}

const [submitLoading, setSubmitLoading] = useState(false);

  const steps = [
    {
      component: (
        <FormStep defaultValues={teamMemberDetails}  CancelButtonLabel="Cancel" showCancelButton={true} >
          <CreateTeamProfile review={true} />
        </FormStep>
      ),
      validationSchema: profileValidationSchema,
      initialValues: teamMemberDetails,
      screen: '1'
    },
    {
      component: (
        <FormStep  backButtonLabel="Back to Profile" continueButtonLabel={"Confirm Changes"}  isLoading={submitLoading}>
          <ReviewTeam review={true} />
        </FormStep>
      ),
      validationSchema: reviewTeamValidationSchema,
      isSubmissionStep: true, // No validation for review step
      screen: '2'
    },
    {
      component: (
        <FormStep continueButtonLabel="Return to Account" showBackButton={false} >
          <SuccessTeamProfile review={true}/>
        </FormStep>
      ),
      validationSchema: reviewTeamValidationSchema,
      isRedirectStep: true,
      screen: '3'
    },
  ];

  const handleNextStep = (formData, nextStep, currentStep) => {
    if (
      formData?.type !== "SCOUT" && 
      currentStep?.screen === "1" &&  
      (!formData?.spendingLimit || !formData?.propertyLimit)
    ) {
      leaveMessagePopup({
        title : 'Are you sure want to proceed?',
       message : 'Without setting usage limits, this will allow unlimited usage.',
        CancelRedirect: () => null, // Stay on the same step
        yesRedirect: () => nextStep(), // Move to the next step
      });
      return; // Prevent navigation until the user selects an option
    }

    if(typeof nextStep === "function") {
      nextStep(); // Move to the next step if no popup is needed    
    }
  };


  const handleSubmit = async (finalData) => {
    try {
      setSubmitLoading(true);

      const upgradePaylaod = {
        primaryUserId: Number(userID),
        teamMemberId: Number(memberId),
        type: 'TEAM_FULL',
        planMrcId: planMrc?.id,
        amount: planMrc?.amount,
        defaultSubsPaymentMethodId: finalData?.defaultSubsPaymentMethodId,
        defaultInAppPaymentMethodId: finalData?.defaultInAppPaymentMethodId,
      }
      const response = await upgradeFullAccessTeamMemberAPI(upgradePaylaod);
      if (!response.success) {
        leaveMessagePopup({
          title: "Error",
          message: error?.message || "Something went wrong",
          yesLable: 'Close',
          cancelLable: '',
          yesRedirect: () => null,
        });
      }
    } catch (error) {
      leaveMessagePopup({
        title: "Error",
        message: error?.message,
        yesLable: 'Close',
        cancelLable: '',
        yesRedirect: () => null,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleCancel = () => {
    console.log("Cancel button clicked!");
    leaveMessagePopup({
      CancelRedirect: () => null, 
      yesRedirect: () =>  history.push("/accountnew/landing"),
    });
    // Add any logic to handle the cancel action (e.g., navigate back, reset form, etc.)
  };


  return (
    <div className={mainCss.clsInnerMainBody}>
      <div>
      {teamMemberDetails?.userId ? (
        <FormProvider>
          <MultiStepForm steps={steps} onSubmit={handleSubmit} onCancel={handleCancel} history={history} redirectPath="/accountnew/landing" 
          onNext={handleNextStep}
          />
        </FormProvider>
        ) : (
          <div className={css.loadingWrapper}>Loading details...</div>
        )}
      </div>
    </div>
  );
};


export default withRouter(connect(null, {
  leaveMessagePopup: LeaveMessagePopup.open
})(ReviewTeamMemberProfile));